import { APIConfig } from 'src/config';
import { Filter, PaginationAndFilter } from 'src/interfaces/common/pagination';
import { RewardTransactionRequest } from 'src/interfaces/rewardTransaction/rewardTransaction';
import axiosClient from '../utils/axios-client';

class RewardApi {
  private userManagementApiUrl = APIConfig.userManagementApiUrl;

  async addReward(rewardDetails: RewardTransactionRequest):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.post(`${this.userManagementApiUrl}rewards`, rewardDetails).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  getUserRewardBalance = async (userName: string) => {
    const paginationObject: PaginationAndFilter = {
      pageSize: 1,
      pageNumber: 1,
      sort: '-1',
      sortBy: 'createdAt',
      filters: [{
        operator: 'equal',
        property: 'userName',
        value: userName
      }],
    };
    const result = await this.getRewardsByPaginationAndFilters(paginationObject);
    return result?.responseData?.records?.length ? result?.responseData?.records[0]?.balance : 0;
  };

  async getRewardsByPaginationAndFilters(options: PaginationAndFilter):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .post(`${this.userManagementApiUrl}rewards/getByPaginationAndFilter`, options)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async getRewardPointsMatrixData(options: Filter[]):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.post(`${this.userManagementApiUrl}rewards/getRewardTransactionMatrix`, options).then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async getRewardCouponFilterData():
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.get('rewards/filtersData');

      return await Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }
}

export const rewardApi = new RewardApi();
